import * as React from 'react';

export function HiddenThead() {
  return <div style={{ display: 'none' }} />;
}
